var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ open: _vm.menuOpen },style:({ right: _vm.right +'px' }),attrs:{"id":"menu-icon"},on:{"click":_vm.toggleMenu}},[_c('img',{attrs:{"src":"images/plus.png","alt":"Open Menu"}})])}
var staticRenderFns = []

export { render, staticRenderFns }